if (!customElements.get('bewow-collection-tabs')) {
  class BewowCollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.onBlockSelect = this.handleBlockSelect.bind(this);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event));
      });

      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    activateTab(tab, moveFocus = false) {
      if (!tab || !this.tabs.includes(tab)) return;

      this.tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });

      if (moveFocus) tab.focus();
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      }
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;

      if (nextIndex === currentIndex && !['Home', 'End'].includes(event.key)) return;

      event.preventDefault();
      this.activateTab(this.tabs[nextIndex], true);
    }

    handleBlockSelect(event) {
      const tab = event.target.closest('[role="tab"]');
      if (tab && tab.closest('bewow-collection-tabs') === this) this.activateTab(tab);
    }
  }

  customElements.define('bewow-collection-tabs', BewowCollectionTabs);
}
